import React from 'react';

const EditIcon: React.FunctionComponent = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="18" height="18" rx="15" fill="#f6f5fd" />
      <path
        d="M10 10H9a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1"
        stroke="#865cd0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m19 8 3 3m1.385-1.415a2.1 2.1 0 0 0-2.97-2.97L12 15v3h3z"
        stroke="#865cd0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditIcon;
